class QuoteModal {
  constructor() {
    this.modal = document.getElementById("QuoteModal");
    this.scrollPosition = 0;
    this.init();
  }

  init() {
    this.interceptQuoteButtons();
    this.handleModalClose();
  }

  interceptQuoteButtons() {
    document.addEventListener(
      "click",
      (event) => {
        const target = event.target;
        const interactiveElement = target.closest(
          'a[href], button, [role="button"]'
        );

        if (!interactiveElement) {
          return;
        }

        if (!this.isQuoteTrigger(interactiveElement)) {
          return;
        }

        if (this.shouldBypassModal(interactiveElement)) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.openModal();
      },
      { capture: true }
    );
  }

  handleModalClose() {
    if (!this.modal) return;

    const closeButton = this.modal.querySelector(".modal__close-button");
    const backgroundOverlay = this.modal.querySelector(
      ".modal__background-overlay"
    );

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.closeModal();
      });
    }

    if (backgroundOverlay) {
      backgroundOverlay.addEventListener("click", () => {
        this.closeModal();
      });
    }

    document.addEventListener("keyup", (event) => {
      if (event.code === "Escape" && this.modal.hasAttribute("open")) {
        this.closeModal();
      }
    });
  }

  isQuoteTrigger(element) {
    if (!element) {
      return false;
    }

    const dataset = element.dataset || {};
    if (dataset.quoteModal === "open") {
      return true;
    }

    if (this.hasQuoteHref(element)) {
      return true;
    }

    const classNameRaw =
      typeof element.className === "string"
        ? element.className
        : element.className && element.className.baseVal
        ? element.className.baseVal
        : "";
    const className = classNameRaw.toLowerCase();

    if (
      className.includes("quote-modal-trigger") ||
      (className.includes("quote") && !className.includes("cart"))
    ) {
      return true;
    }

    const text = (element.textContent || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    const ariaLabel = (element.getAttribute("aria-label") || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    return text === "get a quote" || ariaLabel === "get a quote";
  }

  hasQuoteHref(element) {
    if (!element) {
      return false;
    }

    const href = (element.getAttribute("href") || "").toLowerCase();
    const dataHref = (element.getAttribute("data-href") || "").toLowerCase();

    return href.includes("#get-a-quote") || dataHref.includes("#get-a-quote");
  }

  shouldBypassModal(element) {
    if (!element) {
      return false;
    }

    const dataset = element.dataset || {};
    if (dataset.skipQuoteModal === "true") {
      return true;
    }

    if (this.hasQuoteHref(element)) {
      return false;
    }

    const hasCartClass =
      (element.classList && element.classList.contains("cart-quote-btn")) ||
      (typeof element.closest === "function" &&
        element.closest(".cart__quote-button"));

    return Boolean(hasCartClass);
  }

  openModal() {
    if (!this.modal) return;

    this.scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = "100%";

    this.modal.setAttribute("open", "");
  }

  closeModal() {
    if (!this.modal) return;

    this.modal.removeAttribute("open");

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";

    window.scrollTo(0, this.scrollPosition);
  }
}

const initializeQuoteModal = () => {
  if (window.__quoteModalInstance) {
    return;
  }

  window.__quoteModalInstance = new QuoteModal();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeQuoteModal);
} else {
  initializeQuoteModal();
}

